import { Link } from "react-router-dom"
import { observer } from "mobx-react"
import { Button, Flex, Typography } from "antd"

import refund from "@src/app/assets/icons/refund.svg"
import { OTPEntity } from "@src/pages/otpConfirm/classes/OTPEntity"
import css from "./index.module.css"

type Props = {
  entity: OTPEntity
}

export const OTPSuccessScreen = observer(({ entity }: Props) => {
  return (
    <Flex align="center" className={css.successWrap} gap={48} vertical>
      <img alt="refund" src={refund} style={{ width: "200px" }} />
      <div>
        <Typography.Title level={3} style={{ margin: 0, textAlign: "center" }}>
          Successfully
        </Typography.Title>
        <Typography.Text className={css.successText}>
          {entity.successText}
        </Typography.Text>
      </div>
      <Link id="GENERATED_ID_REFUNDSUCCESS_LINK_VOID_1" to={entity.backPath}>
        <Button
          block
          id="GENERATED_ID_REFUNDSUCCESS_BUTTON_GO_BACK_1"
          size="large"
          type="primary"
        >
          Go back
        </Button>
      </Link>
    </Flex>
  )
})
